const MONTH_MAP = {
  0: 'styczeń',
  1: 'luty',
  2: 'marzec',
  3: 'kwiecień',
  4: 'maj',
  5: 'czerwiec',
  6: 'lipiec',
  7: 'sierpień',
  8: 'wrzesień',
  9: 'październik',
  10: 'listopad',
  11: 'grudzień',
};

const date = new Date();
export const currentDate = `${date.getDate()} ${MONTH_MAP[date.getMonth()]} ${date.getFullYear()}`;
export const currentTime = `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
